import type { Dict } from './en';

export const es: Dict = {
  subtitle: 'Adivina el país del día',
  modes: { classic: 'Clásico', flag: 'Bandera', outline: 'Silueta', connections: 'Conexiones', trivia: 'Trivia', draw: 'Dibuja' },
  recommendations: {
    title: 'También te puede gustar',
    open: 'Abrir {name}',
    games: {
      wormillion: 'Juego diario de geografía con respuestas poco comunes',
      stardewdle: 'Puzles diarios de Stardew Valley',
      cascadle: 'Juego diario de palabras en cascada',
      farhike: 'Reto diario en el mapa con países poco comunes',
    },
  },
  draw: {
    subtitle: 'Dibuja la silueta de memoria',
    askLabel: 'Dibuja este país',
    drawingLabel: 'Dibujando',
    askHint: 'De memoria — sin referencia, un solo intento.',
    blank: 'una hoja en blanco — sin calcar',
    canvasLabel: 'Lienzo de dibujo',
    start: 'Empezar a dibujar',
    undo: 'Deshacer',
    clear: 'Borrar',
    done: 'Listo',
    next: 'Siguiente país',
    score: 'Puntuación',
    accuracy: 'Precisión',
    coverage: 'Cobertura',
    deviation: 'Desviación',
    legendTrue: 'Silueta real',
    legendYours: 'Tu trazo',
    legendOut: 'Te pasaste',
    legendIn: 'Te quedaste corto',
    pts: 'pts',
    learnMore: 'Saber más',
    ranks: [
      'Cartógrafo Real',
      'Maestro cartógrafo',
      'Buen topógrafo',
      'Pulso firme',
      'Aprendiz',
      'Boceto tosco',
      'Vuelve al atlas',
    ],
  },
  trivia: {
    subtitle: 'Diez preguntas de geografía al día',
    loading: 'Cargando las preguntas de hoy…',
    question: 'Pregunta',
    correct: '¡Correcto!',
    wrong: 'Casi',
    next: 'Siguiente pregunta',
    seeResult: 'Ver resultado',
    xpNote: '3 XP por acierto, +10 si aciertas las diez.',
    comeBack: 'Diez preguntas nuevas a medianoche UTC.',
    tiers: ['¡Impecable, 10 de 10!', 'Muy bien jugado.', 'Nada mal. Vuelve mañana.', 'Día difícil. El mundo es grande.'],
  },
  conn: {
    subtitle: 'Ordena 16 países en 4 grupos',
    oneAway: '¡Casi!',
    shuffle: 'Mezclar',
    deselect: 'Deseleccionar',
    submit: 'Enviar',
    mistakes: 'Errores',
    solved: '¡Resuelto!',
    lost: '¡La próxima!',
    nextPuzzle: 'Siguiente',
    flawless: '¡Perfecto, sin errores!',
    wellPlayed: '¡Bien ordenado!',
    lostSub: 'Los cuatro grupos se muestran arriba.',
    guesses: 'Intentos',
  },
  soon: 'pronto',
  streak: 'Racha',
  today: 'Hoy',
  yesterday: 'Ayer',
  nextIn: 'Próximo país en',
  daily: 'Diario',
  unlimited: 'Unlimited',
  nextCountry: 'Siguiente país',
  skip: 'Saltar',
  solved: 'Resueltos',
  best: 'Mejor',
  emptyHint: 'Haz tu primer intento para revelar las pistas.',
  boardScrollLabel: 'Tabla comparativa de intentos. Desplázate horizontalmente para ver todas las pistas.',
  legend: { correct: 'Coincide', incorrect: 'No coincide', numbers: 'respuesta ↑ mayor · ↓ menor', distance: 'más cerca → más lejos' },
  placeholder: 'Escribe un país…',
  guess: 'Adivinar',
  won: '¡Resuelto!',
  lost: 'Sin intentos',
  answerWas: 'El país era',
  answerCard: { viewProfile: 'Ver perfil', northernHemisphere: 'Hemisferio norte', southernHemisphere: 'Hemisferio sur' },
  share: 'Compartir',
  copyLink: 'Copiar enlace',
  copyResult: 'Copiar resultado',
  copyEmbed: 'Copiar inserción',
  saveImage: 'Guardar imagen',
  shareToday: 'Compartir hoy',
  copied: '¡Copiado!',
  cols: { region: 'Región', pop: 'Pob.', area: 'Área', borders: 'Vecinos', gdp: 'PIB', temp: 'Temp.', dist: 'Distancia' },
  colTips: {
    region: "En qué continente está el país. Verde significa el mismo continente que la respuesta.",
    dist: "Distancia en línea recta entre tu intento y la respuesta. Rojo lejos, verde cerca; la flecha apunta hacia la respuesta.",
    borders: "Con cuántos países comparte frontera terrestre. ↑ significa que la respuesta tiene más.",
    temp: "Temperatura media anual, 1991–2020, promediada sobre todo el país, no de la capital.",
    pop: "Población total. ↑ significa que la respuesta tiene más habitantes.",
    area: "Superficie en km². ↑ significa que la respuesta es más grande.",
    gdp: "PIB per cápita en dólares. ↑ significa que la respuesta es más rica por habitante.",
  },
  puzzle: {
    flag: '¿De qué país es esta bandera?',
    outline: '¿Qué país tiene esta silueta?',
  },
  account: {
    signIn: 'Iniciar sesión',
    withGoogle: 'Continuar con Google',
    withDiscord: 'Continuar con Discord',
    tagline: 'Guarda tu racha en todos tus dispositivos',
    signOut: 'Cerrar sesión',
    level: 'Nv',
    viewProfile: 'Ver perfil',
    editProfile: 'Editar perfil',
  },
  settings: {
    title: 'Editar perfil',
    avatar: 'Avatar',
    change: 'Cambiar',
    displayName: 'Nombre',
    bio: 'Biografía',
    bioPh: 'Cuéntales a los exploradores sobre ti…',
    birthday: 'Cumpleaños',
    country: 'País',
    countryNone: 'Sin definir',
    gender: 'Género',
    genders: { male: 'Hombre', female: 'Mujer', other: 'Otro', na: 'Prefiero no decirlo' },
    socials: 'Redes sociales',
    invalidUrl: 'Introduce una URL válida para esa plataforma.',
    date: { year: 'Año', month: 'Mes', day: 'Día' },
    save: 'Guardar',
    saving: 'Guardando…',
    saved: 'Guardado',
    signInRequired: 'Inicia sesión para editar tu perfil.',
    cropTitle: 'Recortar avatar',
    cropHint: 'Arrastra para mover · rueda para zoom',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    pick: 'Elegir imagen',
    uploadError: 'Error al subir — prueba una imagen más pequeña.',
  },
  netError: 'Fallo de red, inténtalo de nuevo.',
  offlinePractice: 'Práctica sin conexión — no puntúa.',
  xp: 'XP',
  levelUp: '¡Subiste de nivel!',
  honors: {
    title: 'Insignias y medallas',
    intro: 'Cada puzle que completas se registra de tres formas: un rango que llevas, una medalla que ganas y una insignia que defiendes.',
    levelT: 'Insignias de nivel',
    levelD: 'La XP de la partida diaria te hace subir por 14 naves grabadas del viaje, del bastón del caminante al buque insignia que da la vuelta al mundo.',
    dailyT: 'Medallas diarias',
    dailyD: 'La clasificación de Hoy ordena a los exploradores por cuántos de los seis modos completan y luego por cuántos intentos les costó. Los tres primeros se llevan oro, plata y bronce, contabilizados en tu perfil para siempre.',
    boardT: 'Insignias de clasificación',
    boardD: 'Mantente entre los tres primeros en Racha, Ilimitado o Nivel y cada día queda grabado en la insignia. Los días de oro, plata y bronce se cuentan por separado.',
    cta: 'Ver la clasificación',
  },
  lb: {
    scoreBreakdown: "Desglose de la puntuación",
    scoreAvg: "Media",
    scoreNote: "Se ordena primero por modos completados y luego por esta media.",
    title: 'Clasificación',
    today: 'Hoy',
    streak: 'Racha',
    level: 'Nivel',
    unlimited: 'Sin límite',
    connections: 'Conexiones',
    myRank: 'Tu posición',
    empty: 'Aún no hay registros — sé el primero.',
    signInToRank: 'Inicia sesión para aparecer en la clasificación.',
    guesses: 'intentos',
    guess1: 'intento',
    totalSolved: 'Resueltos',
    yourStats: 'Tus estadísticas',
    back: 'Volver al juego',
    nav: 'Clasificación',
    viewAll: 'Ver todo',
    dailyMedals: 'Medallas diarias',
    heldBadges: 'Insignias de clasificación',
    notFound: 'Explorador no encontrado.',
  },
  privacy: {
    title: 'Política de Privacidad',
    updated: 'Última actualización: 28 de junio de 2026',
    sections: [
      {
        h: 'Quiénes somos',
        p: ['GeoDle ("nosotros") es un juego diario y gratuito de adivinar países, disponible en geodle.org.'],
      },
      {
        h: 'Qué recopilamos',
        p: [
          'Datos de juego: tus intentos, progreso diario, racha y puntos de experiencia, para hacer funcionar el juego y sincronizarlo entre tus dispositivos.',
          'Datos de cuenta (solo si inicias sesión con Google o Discord): un identificador único, tu nombre visible y tu avatar. Nunca recibimos tu contraseña.',
        ],
      },
      {
        h: 'Cómo usamos tus datos',
        p: [
          'Para guardar y sincronizar tu progreso, calcular rachas y niveles, y mostrar clasificaciones y perfiles públicos de los jugadores conectados.',
          'No vendemos tus datos ni los usamos para publicidad.',
        ],
      },
      {
        h: 'Analítica y cookies',
        p: [
          'Usamos Google Analytics y Microsoft Clarity para entender el uso anónimo y agregado. Estos servicios pueden establecer sus propias cookies; no los usamos para identificarte personalmente.',
          'Usamos una cookie propia para mantener tu sesión y sincronizar tu progreso.',
        ],
      },
      {
        h: 'Tus derechos y eliminación',
        p: [
          'Puedes eliminar permanentemente tu cuenta y todos los datos asociados en cualquier momento con el botón de abajo. La eliminación es inmediata.',
        ],
      },
      { h: 'Contacto', p: ['¿Dudas sobre tus datos? Escribe a contact@geodle.org.'] },
    ],
    deleteAccount: 'Eliminar mi cuenta y datos',
    deleteConfirm: 'Esto elimina permanentemente tu cuenta y todo el progreso. ¿Continuar?',
    deleted: 'Tu cuenta y datos han sido eliminados.',
  },
  terms: {
    title: 'Términos del Servicio',
    updated: 'Última actualización: 28 de junio de 2026',
    sections: [
      {
        h: 'Aceptación',
        p: ['Al usar GeoDle aceptas estos términos. Si no estás de acuerdo, no uses el servicio.'],
      },
      {
        h: 'El servicio',
        p: [
          'GeoDle es un juego diario y gratuito de adivinar países, ofrecido "tal cual", para entretenimiento personal y no comercial. Podemos cambiar, suspender o discontinuar cualquier parte en cualquier momento.',
        ],
      },
      {
        h: 'Cuentas y juego limpio',
        p: [
          'Iniciar sesión es opcional y sirve para sincronizar tu progreso y clasificarte. Eres responsable de la actividad de tu cuenta.',
          'No hagas trampas, no automatices el juego ni manipules puntuaciones, rachas o clasificaciones. Podemos eliminar entradas o cuentas que lo hagan.',
        ],
      },
      {
        h: 'Uso aceptable',
        p: [
          'Elige un nombre y un avatar que no sean ofensivos, infractores ni engañosos. Podemos eliminar contenido o cuentas que incumplan esta regla.',
        ],
      },
      {
        h: 'Propiedad intelectual',
        p: [
          'Los datos de países provienen de conjuntos abiertos (mledoze/countries, Natural Earth). GeoDle es un proyecto independiente, sin afiliación con ningún gobierno u organización.',
        ],
      },
      {
        h: 'Descargo y responsabilidad',
        p: [
          'El servicio se ofrece sin garantías de ningún tipo. En la medida que permita la ley, no somos responsables de los daños derivados de tu uso de GeoDle.',
        ],
      },
      {
        h: 'Cambios',
        p: ['Podemos actualizar estos términos ocasionalmente. Seguir usando el servicio tras un cambio implica que aceptas los nuevos términos.'],
      },
      { h: 'Contacto', p: ['¿Preguntas? Escribe a contact@geodle.org.'] },
    ],
  },
  country: {
    whereOnEarth: 'Dónde está en la Tierra',
    atAGlance: 'De un vistazo',
    howItCompares: 'Comparativa',
    neighbours: 'Países vecinos',
    inGeoDle: '{name} en GeoDle',
    exploreNearby: 'Explora cerca',
    faqTitle: 'Preguntas frecuentes',
    metaTitle: '{name} — Capital, población, superficie y datos | GeoDle',
    metaDesc: '{name}: capital {capital}, población {pop}, superficie {area} km². El {rankPop} país más poblado, en {region}. Datos, mapa, vecinos y más.',
    getToKnow: 'Conoce {name}',
    k: { history: 'Momentos históricos', people: 'Figuras célebres', landmarks: 'Lugares imprescindibles', culture: 'Cultura y sabor' },
    sources: 'Fuentes',
    listTitle: 'Países',
    listSearch: 'Buscar países…',
    listAll: 'Todas las regiones',
    listCount: '{n} países',
    listEmpty: 'Ningún país coincide con tu búsqueda.',
    promoTitle: 'Explora todos los países',
    promoDesc: 'Banderas, capitales, población y un globo interactivo: una página a fondo para los 194 países.',
    promoCta: 'Ver países',
    metaTitleList: 'Todos los países del mundo — banderas, capitales y datos | GeoDle',
    metaDescList: 'Explora todos los países: banderas, capitales, población, superficie y más. Busca y filtra por región, y descubre el mundo en un globo interactivo.',
    play: 'Jugar',
    guessFlag: 'Adivina la bandera',
    guessOutline: 'Adivina la silueta',
    back: 'GeoDle',
    notFound: 'País no encontrado.',
    landlocked: 'Sin litoral',
    coastal: 'Con costa',
    north: 'Norte',
    south: 'Sur',
    landBorders: '{n} fronteras terrestres',
    landBorder: '1 frontera terrestre',
    noBorders: '{name} no tiene fronteras terrestres.',
    locLede: '{name} se encuentra en {subregion}, {region}.',
    locLandlocked: 'No tiene salida al mar.',
    locCoastal: 'Tiene costa marítima.',
    locBorders: 'Comparte frontera terrestre con {n} países.',
    locBorder: 'Comparte frontera terrestre con un país.',
    locIsland: 'Al ser un país insular, no tiene fronteras terrestres.',
    f: { capital: 'Capital', population: 'Población', area: 'Superficie', region: 'Región', subregion: 'Subregión', coast: 'Costa', hemisphere: 'Hemisferio', iso: 'ISO', languages: 'Idiomas', currency: 'Moneda', timezone: 'Zona horaria', calling: 'Prefijo', driving: 'Conducción', tld: 'Dominio', nativeName: 'Nombre nativo' },
    s: {
      popWorld: 'país más poblado del mundo (de {total}).',
      popRegion: 'más poblado de {region} (de {total}).',
      areaLargest: 'más grande por superficie',
      biggerThan: 'mayor que {x}',
      smallerThan: 'menor que {x}',
      perKm2: 'habitantes por km²',
      sparse: 'poco poblado',
      moderate: 'densidad media',
      dense: 'muy poblado',
      morePeople: 'más habitantes que {x}',
      fewerPeople: 'menos que {x}',
      vs: 'vs',
      neighbours: 'vecinos terrestres',
      neighbour: 'vecino terrestre',
    },
    q: {
      capitalQ: '¿Cuál es la capital de {name}?',
      capitalA: 'La capital de {name} es {capital}.',
      popQ: '¿Cuál es la población de {name}?',
      popA: '{name} tiene unos {pop} habitantes — el {rank} país más poblado del mundo.',
      areaQ: '¿Qué tamaño tiene {name}?',
      areaA: '{name} ocupa {area} km², el {rank} país más grande por superficie.',
      regionQ: '¿En qué región está {name}?',
      regionA: '{name} está en {subregion}, {region}.',
    },
  },
  footer:
    'Datos de países: mledoze/countries (ODbL) · Datos de mapas: Natural Earth (dominio público). GeoDle es un proyecto independiente, sin afiliación con ningún gobierno u organización.',
};
